import { render } from "./ProfileInfo.vue?vue&type=template&id=0e9526fd"
import script from "./ProfileInfo.vue?vue&type=script&lang=js"
export * from "./ProfileInfo.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "0e9526fd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0e9526fd', script)) {
    api.reload('0e9526fd', script)
  }
  
  module.hot.accept("./ProfileInfo.vue?vue&type=template&id=0e9526fd", () => {
    api.rerender('0e9526fd', render)
  })

}

script.__file = "src/views/settings/modules/ProfileInfo.vue"

export default script